<template>
  <panel-main-template>
    <template v-slot:page-title>Мой аккаунт</template>
    <template v-slot:page-content>
      <div class="account--container">
        <div class="account--tabs">
          <ul class="tabs-container">
            <li
                @click="clickTab(item)"
                v-bind:class="{ active: item.isActive }"
                v-for="item in tabListComputed"
                :key="item.id"
            >
              {{ item.name }}
            </li>
        </ul>
        </div>
        <div class="account--account-main" v-if="activeTabIndex == 1">
          <account-main></account-main>
        </div>
        <div 
          class="account--account-contract" 
          v-if="activeTabIndex == 2 && checkPermission('user')"
        >
          <account-contract></account-contract>
        </div>
        <div class="account--account-contract" v-if="activeTabIndex == 3">
          <security></security>
        </div>
      </div>
    </template>
  </panel-main-template>
</template>

<script>
// @ is an alias to /src

import PanelMainTemplate from "../../components/panel/MainTemplate";
import AccountMain from "../../components/panel/account/AccountMain";
import AccountContract from "../../components/panel/account/AccountContract";
import Security from '../../components/panel/account/Security.vue';
import permissionMixin from "@/components/mixins/Permissions";

export default {
  name: "Account",
  components: {
    AccountContract,
    AccountMain,
    PanelMainTemplate,
    Security
  },
  mixins: [permissionMixin],
  data() {
    return {
      tabs: [
        {
          id: 1,
          name: "Основные данные",
          isActive: true
        },
        {
          id: 2,
          name: "Юр.лицам/ИП",
          isActive: false
        },
        {
          id: 3,
          name: "Безопасность",
          isActive: false
        },
      ]
    };
  },
  watch: {

  },
  computed: {
    tabListComputed(){
      let result = [];

      for(let key in this.tabs){
        if(this.tabs[key].id === 2 && !this.checkPermission('user')){
          continue;
        }else{
          result.push(this.tabs[key]);
        }
      }
      return result;
    },
    activeTabIndex() {
      let result = 0;
      this.tabs.forEach(function(item) {
        if (item.isActive) {
          result = item.id;
        }
      });
      return result;
    }
  },
  methods: {
    clickTab(item) {
      for (let key in this.tabs) {
        if (this.tabs[key].id === item.id) {
          this.tabs[key].isActive = true;
        } else {
          this.tabs[key].isActive = false;
        }
      }
    },
  },
  metaInfo: {
    title: "Мой аккаунт - Enroller",
    meta: [
      {
        name: 'viewport',
        content: "width=device-width, initial-scale=1, minimum-scale=1, user-scalable=no"
      }
    ]
  },
  created() {

  }
};
</script>

<style scoped lang="less">

</style>
